import VehicleDetail from "./VehicleDetail";
import { vehiclesData } from "../data/vehiclesData";

function MercedesClasseE() {
  return <VehicleDetail vehicle={vehiclesData.mercedesE} />;
}

export default MercedesClasseE;